<div class="spinner-bg">
  <div class="loading-modal">
    <div class="loader m-auto" [class.loader-sm]="small"></div>
  </div>
</div>
